const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/old_components/components/private/ElementFrame.tsx';
import * as React from 'react';
import _ from 'lodash';
import { Theme, useTheme } from '@mui/material/styles';
import { css, cx } from '@emotion/css';

export interface ElementFrameProps {
    component?: 'div' | 'span' | 'section' | 'button' | 'label'; // use semantic html
    forId?: string;
    className: string | undefined;
    style: React.CSSProperties | undefined;
    formEditClassName: string | undefined;
    formEditStyle: React.CSSProperties | undefined;
    formViewClassName: string | undefined;
    formViewStyle: React.CSSProperties | undefined;
    onClick?: (evt?: any) => void;
    children?: any;
    isFormView?: boolean;
}

// accessability: outline is important to mark a focused element
const getButtonCSSClasses = (theme: Theme) => ({
    root: css`
        &:focus {
            outline: 0;
        }
        &:focus > span {
            color: ${theme.palette.text.primary};
        }
        // remove any button decoration, since button is also used for other cases (allowing keyboard focus and click)
        font-size: 100%;
        font-family: inherit;
        border: 0;
        padding: 0;
        background-color: inherit;
    `,
});

export const ElementFrame = (props: ElementFrameProps) => {
    const theme = useTheme();
    const buttonClasses = getButtonCSSClasses(theme);

    const className = cx([
        props.className, //
        props.isFormView ? props.formViewClassName : props.formEditClassName,
    ]);

    const inlineStyle = {
        ...props.style,
        ...(props.isFormView ? props.formViewStyle : props.formEditStyle),
    };
    const makeDiv = () => (
        <div className={className} style={inlineStyle} onClick={props.onClick}>
            {props.children}
        </div>
    );

    const makeButton = () => (
        <button tabIndex={0} className={cx(className, buttonClasses.root)} style={inlineStyle} onClick={props.onClick}>
            {props.children}
        </button>
    );
    switch (props.component) {
        case 'span':
            return (
                <span className={className} style={inlineStyle}>
                    {props.children}
                </span>
            );
        case 'label':
            return (
                <label className={className} htmlFor={props.forId} style={inlineStyle}>
                    {props.children}
                </label>
            );
        case 'div':
            return makeDiv();

        case 'section':
            if (props.onClick) {
                return makeButton();
            } else {
                return (
                    <section className={className} style={inlineStyle}>
                        {props.children}
                    </section>
                );
            }

        case 'button':
            return makeButton();

        default:
            if (!props.component && !props.onClick && _.isEmpty(className) && _.isEmpty(inlineStyle)) {
                return <>{props.children}</>;
            } else {
                return makeDiv();
            }
    }
};
